import React from 'react';
import ReactDOM from 'react-dom/client';
import './core/styles/index.css';
import App from './core/App';
import reportWebVitals from './core/reportWebVitals';
import { AuthProvider } from './core/context/AuthContext';
import { applyLockedBrandToDocument } from './core/utils/lockedAppMode';
import { configureAuthLifecycle } from './core/services/authLifecycle';
import { createProductComposition } from './products';

applyLockedBrandToDocument();
const composition = createProductComposition();
configureAuthLifecycle(composition.authLifecycle);

const root = ReactDOM.createRoot(document.getElementById('root'));
 root.render(
//   <React.StrictMode>
     <AuthProvider>
       <App composition={composition} />
     </AuthProvider>
//   </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
